export default __webpack_public_path__ + "static/media/template_9.0439266d.png";